import React from 'react';

function LoadingSpinner({ message = "Processing..." }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md shadow-2xl">
        <div className="flex flex-col items-center">
          {/* Animated Spinner */}
          <div className="relative w-20 h-20 mb-6">
            <div className="absolute inset-0 border-4 border-gray-200 rounded-full"></div>
            <div className="absolute inset-0 border-4 border-blue-600 rounded-full border-t-transparent animate-spin"></div>
            <div className="absolute inset-2 border-4 border-green-500 rounded-full border-t-transparent animate-spin" style={{ animationDelay: '0.15s' }}></div>
            <div className="absolute inset-4 border-4 border-purple-500 rounded-full border-t-transparent animate-spin" style={{ animationDelay: '0.3s' }}></div>
          </div>

          {/* Message */}
          <h3 className="text-xl font-bold text-gray-800 mb-2">
            {message}
          </h3>

          <p className="text-gray-600 text-center text-sm">
            Analyzing gift combinations...
          </p>

          {/* Animated dots */}
          <div className="flex gap-1 mt-4">
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoadingSpinner;
